import axios from "axios";
import { getUserData } from "../Helpers";


const CreateApiService = axios.create({
  baseURL: process.env.REACT_APP_LARAVEL_DEV_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});


CreateApiService.interceptors.request.use(
  config => {
    // console.log(config)
    const {user_token} = getUserData();
    if (user_token) {
      config.headers['x-auth-token'] = user_token ?? null;
    } 
    return config;
  },
  error => {
    return Promise.reject(error)
  }
);


export default CreateApiService;